export const resortFeeList = ["Flat", "Percent", "Per Guest"];

export const villaHomeTemplateList = ["Villa", "Home Room Type"];

export const frequencyList = ["Daily", "Day of Arrival"];

export const postTypeList = ["Resort Fee"];

export const typeList = ["None", "Villa", "Home"];

/** Room Type Maintenance always books as nightly (hourly disabled in UI/export). */
export const ROOM_TYPE_IS_NIGHTLY = true;
export const ROOM_TYPE_IS_HOURLY = false;
